import axiosInstance from '../axiosInterceptor/axiosInstance'

// Body: { tosVersionId, marketingConsent, dataSharingConsent }
const acceptConsent = (payload) => axiosInstance.post('v1/consent/accept', payload)

export default acceptConsent
